export default __webpack_public_path__ + "static/pixery-logo-f8eb3b453cbe4b483f443ed46be00ed9.svg";